// extracted by mini-css-extract-plugin
export default {"root":"BindWxPage_root__BcNym"};